// frontend/src/sentry.js
import * as Sentry from "@sentry/react";
import { shouldDropBrowserSentryEvent } from "./shared/utils/sentryEventFilters.js";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn && import.meta.env.MODE !== "development") {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE || "development",
    sendDefaultPii: true,
    tracesSampleRate: import.meta.env.MODE === "production" ? 0.1 : 1.0,
    integrations: [
      Sentry.browserTracingIntegration({
        tracePropagationTargets: [
          "localhost",
          "127.0.0.1",
          /^https:\/\/whatsapp\.bubakii\.co\.za/,
          /^https:\/\/api\.bubakii\.co\.za/,
        ],
      }),
    ],
    release: import.meta.env.VITE_SENTRY_RELEASE || "bubakii-logistics@1.0.0",
    initialScope: {
      tags: { component: "frontend", service: "bubakii-logistics" },
    },
    beforeSend(event, hint) {
      if (shouldDropBrowserSentryEvent(event, hint)) {
        return null;
      }
      return event;
    },
    beforeBreadcrumb(breadcrumb) {
      if (
        import.meta.env.MODE === "production" &&
        breadcrumb.category === "console" &&
        breadcrumb.level === "debug"
      ) {
        return null;
      }
      return breadcrumb;
    },
  });
} else if (import.meta.env.MODE !== "development") {
  console.warn(
    "[FRONTEND]: Sentry DSN is invalid or missing. Sentry will not be initialized."
  );
}

export default Sentry;
